import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { CustomTable, Text } from '../../../shared/uiComponents';
import { Users } from '../../../shared/Assets/menuIcons';
import { MobileViewTemporaryAuthorizations } from '../MobileView';
import { TableBodyTemporaryAuthorization } from './tableInfo';
import { TEMPORARY_AUTHORIZATION_HEADERS } from '../helpers';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getTemporaryAuthorizations } from '../../../redux/State/clientSlice/dashboardSlice';

const TemporaryAuthorizationsInfo = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const loading = useSelector((state) => state.dashboard.loading);
	const temporaryAuthorizations = useSelector((state) => state.dashboard.temporaryAuthorizations);

	useEffect(() => {
		const page = params.get('tempAuthPage') || '1';
		const pageSize = params.get('tempAuthPageSize') || '8';
		dispatch(
			getTemporaryAuthorizations({
				page,
				pageSize,
			}),
		);
	}, [params, dispatch]);

	return temporaryAuthorizations.query?.length ? (
		<div className="dashboardCard dashboardTempAuthCard">
			<div className="dashboardHeader">
				<div className="header">
					<div className="headerIcon">
						<Users />
					</div>
					<Text type="h6" font="header" fontWeight="semiBold" title="Temporary Authorizations" />
				</div>
			</div>
			<CustomTable
				siblingCount={0}
				headers={TEMPORARY_AUTHORIZATION_HEADERS}
				data={temporaryAuthorizations}
				TableBody={TableBodyTemporaryAuthorization}
				loading={loading}
				type="tempAuth"
			/>
			<MobileViewTemporaryAuthorizations data={temporaryAuthorizations} />
		</div>
	) : null;
};

export default TemporaryAuthorizationsInfo;
